import { Types } from "@ioc/types";
import { IHttpService } from "@modules/infra/http/models/IHttpService";
import { inject, injectable } from "inversify";
import { IGetTaxReceiptWithActionsDTO } from "../dtos/IGetTaxReceiptWithActionsDTO";
import { IGetTotalQTVolLTService } from "../models/IGetTotalQTVolLTService";

@injectable()
export class GetTotalQTVolLTService implements IGetTotalQTVolLTService {
  // @ts-ignore
  @inject(Types.IHttpService) private httpInstance: IHttpService;

  execute(
    data: IGetTaxReceiptWithActionsDTO
  ): Promise<{ quantityAtem: number; quantityPosh: number; rate: number }> {
    return this.httpInstance.get<{
      quantityAtem: number;
      quantityPosh: number;
      rate: number;
    }>(
      `/dashboard-posh/taxReceipt?action=${data.action}&companies_id=${data.companies_id}&from=${data.from}&to=${data.to}`
    );
  }
}
